import APIService from '../api.service';

export const All = (params) => {
    return APIService.get(`/v01/internal-transfers`, {
        params: {
            per_page: params.perPage,
            page: params.page,
            keyword: params.keyword,
            status: params.status,
            from_date: params.fromDate,
            to_date: params.toDate,
            from_warehouse_id: params.from_warehouse_id,
            to_warehouse_id: params.to_warehouse_id,
        },
    });
};

export const Create = (body, config) => {
    return APIService.post(`/v01/internal-transfers`, body, config);
};

export const Get = (id) => {
    return APIService.get(`/v01/internal-transfers/${id}`);
};

export const Update = (id, body, config) => {
    return APIService.put(`/v01/internal-transfers/${id}`, body, config);
};

export const Delete = (id) => {
    return APIService.delete(`/v01/internal-transfers/${id}`);
};

export const Export = (params) => {
    return APIService.get(`/v01/internal-transfers/export`, {
        params: {
            from_date: params.fromDate,
            to_date: params.toDate,
            from_warehouse_id: params.from_warehouse_id,
            to_warehouse_id: params.to_warehouse_id,
            ids: params.ids,
        },
        responseType: 'blob',
    });
};

export const WarehouseOptions = () => {
    return APIService.get(`/v01/internal-transfers/warehouse-options`);
};

export const StockAvailability = (params) => {
    return APIService.get(`/v01/internal-transfers/stock-availability`, {
        params: {
            warehouse_id: params.warehouse_id,
            product_id: params.product_id,
            product_type: params.product_type,
        },
    });
};

export const Cancel = (id) => {
    return APIService.post(`/v01/internal-transfers/${id}/cancel`);
};

export const Confirm = (id) => {
    return APIService.post(`/v01/internal-transfers/${id}/confirm`);
};

export const Transfer = (id) => {
    return APIService.post(`/v01/internal-transfers/${id}/transfer`);
};

const InternalTransferService = {
    All,
    Create,
    Get,
    Update,
    Delete,
    Cancel,
    Confirm,
    Transfer,
    Export,
    WarehouseOptions,
    StockAvailability,
};

export default InternalTransferService;
